import React, { Component } from 'react'
import { Table, Divider, Tag, Button } from 'antd';

// 序号	
// 流程名称	
// 任务摘要	
// 送达时间
export default class TodoList extends Component {
  state={
    todoList:[],
    columns: [
      {
        title: '序号',
        dataIndex: 'taskTitle',
        key: 'taskTitle',
      },
      {
        title: '任务摘要',
        dataIndex: 'taskNam',
        key: 'taskNam',
      },
      {
        title: '送达时间',
        key: 'allctTim',
        dataIndex: 'allctTim',
      },
      {
        title: '操作',
        key: 'action',
        render: (text, record) => (
          <Button type="link" size="small" onClick={() => this.todo(record)}>审批</Button>
        ),
      },
    ],

    pagination: {
      total:0, 
      pageSize:10, 
      current:1
    },
  }
  componentDidMount(){
    this.getToDoList()
  }
  todo = (record) => {
    if(record.uid.includes("client-pc")){
        // 获取 参数
        const token = tool.getCookie('token');
        const bussId = record.bussId;
        const taskId = record.taskId;
        const instId = record.instId;
        const nodeId = record.nodeId;
        // 获取当前页面的域名
        const domain = window.location.origin;
        // 拼接跳转的 URL
        const basePath = record.uid;
        const params = new URLSearchParams({
            token: token,
            bussId: bussId,
            taskId: taskId,
            instId: instId,
            nodeId: nodeId
            // 可以根据需要添加更多参数
        });
        const url = `${domain}${basePath}?${params.toString()}`;
        // 在新标签页中打开拼接好的 URL
        window.open(url, '_blank');
    } else {
        tool.popUIByUcv(record.uid, {"currentData":record}, record.taskTitle)
    }
  }
  handleTableChange = (pagination, filters, sorter) => { 
    const pager = { ...this.state.pagination }
    pager.current = pagination.current
    pager.pageSize = pagination.pageSize
    this.setState({
      pagination: pager,
    },() => {this.getToDoList()})
  }
  getToDoList = () => { 
    const pendingUrl = sgiConfig.service_csp + '/task/my/pending'; //待办接口
    let req = {
      "values":{
        "executor":tool.getCookie('userId')
      }
    }
    commonClient.simplecall(pendingUrl, req, (res) => { 
      const pagination = { ...this.state.pagination }
      pagination.total = res.head.pageCount
      this.props.getCount(res.head.pageCount)
      this.setState({
        todoList: res.body,
        pagination
      })
    }, false, null, null, (request) => {
      const {pageSize, current} = this.state.pagination
      request.head.pageSize = pageSize
      request.head.offset = current
    })
  }
  render() {
    let { columns, todoList, pagination } = this.state
    let paginationOps = {
      ...pagination,
      size:"small", 
      showTotal:num => `总数${num}`,
      showSizeChanger:true,
      pageSizeOptions:['10','20','30','40','50','60','70','80','90','100']
    }

    return (
      <Table columns={columns} 
      dataSource={todoList} 
      size="small" 
      pagination={paginationOps} 
      bordered
      onChange={this.handleTableChange}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/workbench/Factor/tablist/TodoList.js